import { Flex, Badge } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";
import { CobrancaContaItemComposicao } from "features/cobranca/typings";
import { useState } from "react";
import ModalModificarTaxas from "./ModalModificarTaxas";

interface TableItemRowProps {
  composicao: CobrancaContaItemComposicao;
  onChangeTaxas?: (taxas: {
    taxaMulta: number;
    taxaJuros: number;
    taxaCobranca: number;
  }) => any;
}
function TableItemRow({ composicao, onChangeTaxas }: TableItemRowProps) {
  const [isOpenModalModificarTaxas, setIsOpenModalModificarTaxas] =
    useState(false);

  const onOpen = () => setIsOpenModalModificarTaxas(true);
  const onClose = () => setIsOpenModalModificarTaxas(false);

  return (
    <>
      {isOpenModalModificarTaxas ? (
        <ModalModificarTaxas
          visible={isOpenModalModificarTaxas}
          onClose={onClose}
          onSubmit={(taxas) => {
            onChangeTaxas?.(taxas);
            onClose();
          }}
          defaultValues={{
            taxaCobranca: composicao.taxaCobranca || 0,
            taxaJuros: composicao.taxaJuros || 0,
            taxaMulta: composicao.taxaMulta || 0,
          }}
        />
      ) : null}
      <Flex flex={1} position="relative" onClick={onOpen} cursor="pointer">
        <Flex flex={2} ml={4} noOfLines={1}>
          {composicao.nome}
        </Flex>
        <Flex flex={1} justifyContent="flex-end">
          {formatMoney(composicao.valorOriginal)}
        </Flex>
        <Flex flex={1} justifyContent="flex-end" gap={2}>
          {composicao.taxaMulta > 0 ? (
            <Badge
              colorScheme="red"
              h={"20px"}
              onClick={onOpen}
              cursor="pointer"
            >
              {composicao.taxaMulta}%
            </Badge>
          ) : null}
          {formatMoney(composicao.multa)}
        </Flex>
        <Flex flex={1} justifyContent="flex-end" gap={2}>
          {composicao.taxaJuros > 0 ? (
            <Badge
              textTransform="lowercase"
              colorScheme="red"
              h={"20px"}
              onClick={onOpen}
              cursor="pointer"
            >
              {composicao.taxaJuros}% ao mês
            </Badge>
          ) : null}
          {formatMoney(composicao.juros)}
        </Flex>
        <Flex flex={1} justifyContent="flex-end" gap={2}>
          {composicao.taxaCobranca > 0 ? (
            <Badge
              textTransform="lowercase"
              colorScheme="red"
              h={"20px"}
              onClick={onOpen}
              cursor="pointer"
            >
              {composicao.taxaCobranca}%
            </Badge>
          ) : null}
          {formatMoney(composicao.valorTaxaCobranca)}
        </Flex>
        <Flex flex={1} justifyContent="flex-end">
          {formatMoney(composicao.atualizacaoMonetaria)}
        </Flex>
        {/* <Flex flex={1} justifyContent="flex-end">
        {formatMoney(composicao.honorarios)}
      </Flex> */}
        <Flex flex={1} justifyContent="flex-end">
          {formatMoney(composicao.total)}
        </Flex>
      </Flex>
    </>
  );
}

export default TableItemRow;
